import { Configuration, EventType, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_CLIENT_ID, MSAL_TENANT_ID } from '../config.js';
import { reportClientError } from '../telemetry/reportClientError.js';

const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
    redirectUri: `${window.location.origin}/`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// The UI sends its own ID token (audience = this app's client ID), not a
// custom api://<app> resource's access token. The edge (Kong / APIM) validates
// the token's signature and audience before the bff is invoked; the bff only
// decodes it and does NOT re-verify. A standard delegated scope is still
// required to acquire tokens at all; openid/profile are built into every
// tenant by default, so this needs no "Expose an API" registration step.
export const apiScope = ['openid', 'profile'];

// Catches silent-token-refresh failures during normal use (not just the
// one-time init path handled in AuthProvider.tsx). LOGIN_FAILURE does not
// exist on this version's EventType — ACQUIRE_TOKEN_FAILURE covers both
// silent and interactive token acquisition failures.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE && event.error) {
    reportClientError('msal_error', event.error.message, event.error.stack);
  }
});
